import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { TranscriptChunk } from "../models/TranscriptChunk";

export const useGetTransciptSource = () => {
  const {
    data: source,
    call,
    isLoading,
    isFailed,
    setData: setSource,
  } = useApiPrivateRequest<TranscriptChunk>(
    (response) => new TranscriptChunk(response),
  );
  const getTranscriptSource = async (id: number, chunkId?: number) => {
    await call(`/transcripts/${id}/source`, "GET", {
      chunkId,
    });
  };

  return { source, getTranscriptSource, isLoading, isFailed, setSource };
};
